module.exports = __webpack_public_path__ + "img/des-action-puzzle.a27a0b41.jpeg";